import React from 'react'
import classNames from 'classnames'
import { createSelector } from 'reselect'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import CMPPlaceholder from '../cmp/CMPPlaceholder'
import Outdoor from '../outdoor/Outdoor'
import MenuCategoriesGE from '../menu/MenuCategoriesGE'
import { useSelector } from 'react-redux'
import { selectIsMapFullScreen } from '../../store/map/map.selectors'
import { isUIElementDisplayed } from '../../store/ui/ui.selectors'
import UserArea from '../UserAccount/UserArea'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import UserAccountIncentivePopin from '../UserAccount/connectionIncentive/UserAccountIncentivePopin'

const getPageSpecificClasses = createSelector(
  (store, props) => props.pageClassManager && props.pageClassManager(store, props),
  customClasses => customClasses || []
)

const getCommonClasses = createSelector(
  selectIsMapFullScreen,
  isUIElementDisplayed(UI_ELEMENTS.POPIN),
  isUIElementDisplayed(UI_ELEMENTS.SUGGEST),
  isUIElementDisplayed(UI_ELEMENTS.MENU_PE),
  isUIElementDisplayed(UI_ELEMENTS.MAP_TOOLS_PE),
  (isMapFullScreen, isPopinDisplayed, isSuggestDisplayed, isMenuPEDisplayed, isMapToolsPEDisplayed) => [
    isMapFullScreen && PAGE_CLASSES.withFullscreenMap,
    isPopinDisplayed && PAGE_CLASSES.withDetail,
    isSuggestDisplayed && PAGE_CLASSES.withSuggest,
    isMenuPEDisplayed && PAGE_CLASSES.withMenuPEDisplayed,
    isMapToolsPEDisplayed && PAGE_CLASSES.withMapToolsPEDisplayed
  ]
)

export default function Page({ cssClasses = [], children, ...props }) {
  const commonClasses = useSelector(state => getCommonClasses(state, props))
  const pageSpecificClasses = useSelector(state => getPageSpecificClasses(state, props))
  const className = classNames(...cssClasses, ...commonClasses, ...pageSpecificClasses)

  return (
    <div className={className}>
      <CMPPlaceholder key="CMPPlaceholder" />
      <Outdoor />
      <MenuCategoriesGE />
      <UserArea />
      <UserAccountIncentivePopin />
      {children}
    </div>
  )
}
